import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import { RECEIVING_MESSAGES } from "../../shared/receivingInvoices";
import { createSnackbarHelpers } from "../../shared/snackbar";

export function ReceivingInvoicesViewModel(logout, addSnackbar) {
  const [filters, setFilters] = useState({
    supplier: { value: -1, label: "All suppliers" },
    startDate: null,
    endDate: null,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [receivingInvoices, setReceivingInvoices] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [reportFilters, setReportFilters] = useState({
    type: { value: -1, label: "Select report" },
    startDate: null,
    endDate: null,
  });
  const [reportInProgress, setReportInProgress] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const [suppliers, setSuppliers] = useState([]);

  const { showSuccess, showError } = createSnackbarHelpers(addSnackbar);

  const getReceivingInvoices = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      filter: filters,
    };
    let callResult = await makePostApiCall(`receivingInvoices`, payload);
    setLoading(false);
    if (callResult.success) {
      setReceivingInvoices(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(RECEIVING_MESSAGES.listLoadFailed);
    }
  };

  const deleteReceivingInvoice = async function (invoiceId, index) {
    let callResult = await makePostApiCall(
      `deleteReceivingInvoice/${invoiceId}`,
      {},
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getReceivingInvoices(null, 0);
      showSuccess(RECEIVING_MESSAGES.deleted);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(RECEIVING_MESSAGES.deleteFailed);
    }
  };

  const askDeleteReceivingInvoice = function (invoice, index) {
    if (invoice.status === 1) {
      showError(RECEIVING_MESSAGES.closedDelete);
    } else {
      setEmptyModelOpen({
        childComponent: (
          <DeleteConfirmationForm
            buttonMessage="Delete"
            confirmAction={() => deleteReceivingInvoice(invoice.id, index)}
            message={`Are you sure you want to delete invoice ${invoice.invoice_number} from ${invoice.supplier_name}?`}
            setOpen={setEmptyModelOpen}
          />
        ),
        open: true,
      });
    }
  };

  const generateReceivingReport = async function () {
    setReportInProgress(true);
    let callResult = await makePostApiCall(
      `generateReceivingReport`,
      reportFilters,
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(RECEIVING_MESSAGES.reportFailed);
    }
    setReportInProgress(false);
  };

  const filterComponents = [
    <DateRangeFilter
      startDate={filters.startDate}
      endDate={filters.endDate}
      onChange={(name, value) =>
        setFilters({
          ...filters,
          [name]: value,
        })
      }
      resetFilter={() =>
        setFilters({
          ...filters,
          startDate: null,
          endDate: null,
        })
      }
    />,
    <FilterSingleSelectDropdown
      header="Supplier"
      onChange={(value) =>
        setFilters({
          ...filters,
          supplier: value,
        })
      }
      options={suppliers}
      resetFilter={() =>
        setFilters({
          ...filters,
          supplier: { value: -1, label: "All suppliers" },
        })
      }
      valueName="supplier"
      value={filters.supplier}
    />,
  ];

  const resetFilters = () => {
    const filterReset = {
      supplier: { value: -1, label: "All suppliers" },
      startDate: null,
      endDate: null,
    };
    setFilters(filterReset);

    setShowFilters(false);
    getReceivingInvoices(null, 1, filterReset);
  };

  const getSuppliers = async function () {
    let callResult = await makeGetApiCall(`suppliersForDropdown`);
    if (callResult.success) {
      setSuppliers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(RECEIVING_MESSAGES.loadSuppliersFailed);
    }
  };

  return {
    askDeleteReceivingInvoice,
    emptyModal,
    getReceivingInvoices,
    loading,
    receivingInvoices,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    filters,
    resetFilters,
    showFilters,
    setShowFilters,
    filterComponents,
    getSuppliers,
  };
}
